import React from 'react';
import { FadeIn, SectionDivider, CtaButton } from '../ui';
import { Star } from 'lucide-react';
export const SocialProofSections = () => {
  return <div className="bg-mystic-900 relative" data-id="element-345">
      {/* BLOQUE 10: TESTIMONIOS */}
      <section className="py-12 px-4" data-id="element-346">
        <div className="max-w-6xl mx-auto" data-id="element-347">
          <FadeIn data-id="element-348">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16" data-id="element-349">
              Lo que dicen quienes ya lo hicieron
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-350">
              {[{
              quote: "Pagué entre dos 'maestros' casi $680 en seis meses. Nada. Leí el manual un domingo por la tarde, empecé el lunes en la noche. El jueves me escribió preguntando si podíamos hablar. Todavía no lo proceso del todo.",
              name: 'Valeria M.',
              meta: '29 años · Colombia',
              initial: 'V'
            }, {
              quote: 'Nos separamos porque su familia nunca me aceptó. Cuatro años juntos y lo perdí por ellos. Terminé la tercera noche un viernes. El domingo en la tarde me llamó él. Llevamos dos meses volviendo a construir lo nuestro.',
              name: 'R.T.',
              meta: '38 años · México',
              initial: 'R'
            }, {
              quote: 'Honestamente lo compré sin creer mucho, era $7, dije que no perdía nada. Lo que no esperaba fue que por primera vez entendiera POR QUÉ los otros rituales no habían funcionado. Eso solo ya valía más que lo que pagué.',
              name: 'Carolina V.',
              meta: 'Venezuela',
              initial: 'C'
            }].map((testimonial, idx) => <div key={idx} className="glass-panel p-8 rounded-xl relative mt-8 md:mt-0" data-id="element-351">
                  {/* Avatar Initials */}
                  <div className="absolute -top-8 left-8 w-16 h-16 rounded-full bg-mystic-900 border border-gold flex items-center justify-center text-2xl font-serif text-gold shadow-lg" data-id="element-352">
                    {testimonial.initial}
                  </div>

                  <div className="flex gap-1 text-gold mb-6 mt-4" data-id="element-353">
                    {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-354" />)}
                  </div>

                  <p className="text-text-primary italic font-serif text-lg leading-relaxed mb-8" data-id="element-355">
                    "{testimonial.quote}"
                  </p>

                  <div className="border-t border-white/10 pt-4" data-id="element-356">
                    <p className="font-bold text-white" data-id="element-357">{testimonial.name}</p>
                    <p className="text-sm text-text-secondary" data-id="element-358">
                      {testimonial.meta}
                    </p>
                  </div>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </section>

      <SectionDivider data-id="element-359" />

      {/* BLOQUE 11: CTA #2 */}
      <section className="py-12 px-4 text-center" data-id="element-360">
        <FadeIn data-id="element-361">
          <CtaButton subtext="Acceso inmediato · Funciona desde cualquier país · Garantía de 7 días" data-id="element-362">
            → SÍ, QUIERO EMPEZAR ESTA NOCHE POR $7
          </CtaButton>
        </FadeIn>
      </section>
    </div>;
};